










































import { Component, Vue } from 'vue-property-decorator';
import { ALL_OCCUPATIONS } from '@/queries/Occupation';
import { GQL_occupations } from '@/queries/__generated__/occupations';
import { GQL_occupationSelections, GQL_occupationSelections_currentUnit_occupationSelections } from '@/queries/__generated__/occupationSelections';
import { GQL_OccupationSelectionCreate } from '@/queries/global';
import { CURRENT_UNIT } from '@/queries/Application';
import { SmartQuery } from 'vue-apollo-decorator';
import { GQL_currentUnit, GQL_currentUnit_currentUnit } from '@/queries/__generated__/currentUnit';
import { GQL_createOccupationSelection } from '@/queries/__generated__/createOccupationSelection';
import { GQL_occupationSearch_occupationSearch } from '@/queries/__generated__/occupationSearch';
import { IRules } from '../UI/Form/ValidationModule';
import { validateRequired } from '../UI/Form/Validations';
import { InMemoryCache } from 'apollo-cache-inmemory';
import gql from 'graphql-tag';
import { OCCUPATION_SELECTIONS } from './occupationSelection';

const OCCUPATION_SEARCH = gql`
  query occupationSearch (
    $term: String!,
    $limit: Int,
    $offset: Int,
  ) {
    occupationSearch(
      term: $term,
      limit: $limit,
      offset: $offset,
    ) {
        id
        name
        code
        validFrom
    }
  },
`;

const CREATE_OCCUPATION_SELECTION = gql`
  mutation createOccupationSelection($occupationSelection: OccupationSelectionCreate!) {
    createOccupationSelection(input: { occupationSelection: $occupationSelection }) {
      occupationSelection {
         id
        occupation {
          id
          name
          code
          validFrom
        }
      }
    }
  },
`;

@Component
export default class OccupationSelectionForm extends Vue {
  @SmartQuery<OccupationSelectionForm, GQL_occupationSelections>({
    query: OCCUPATION_SELECTIONS,
    update: data => data.currentUnit.occupationSelections,
  }) private occupationSelections!: GQL_occupationSelections_currentUnit_occupationSelections[];

  @SmartQuery<OccupationSelectionForm, GQL_currentUnit>({
    query: CURRENT_UNIT,
    result({ data }) {
      this.occupationSelection.unitId = data.currentUnit.id;
    },
  }) private currentUnit!: GQL_currentUnit_currentUnit;

  private validForm = false;
  private OCCUPATION_SEARCH = OCCUPATION_SEARCH;
  private CREATE_OCCUPATION_SELECTION = CREATE_OCCUPATION_SELECTION;
  private occupationSelection: GQL_OccupationSelectionCreate = {
    occupationId: '',
    unitId: '',
  };

  private rules: IRules = {
    occupationId: [
      {
        validation: validateRequired(),
        message: i18n => i18n.t('Error.required', { field: i18n.t('Occupation.occupation') }),
      },
      {
        validation: ({ dataValue }) => !this.occupationSelections.map(o => o.occupation.id).includes(dataValue),
        message: i18n => i18n.t('Error.alreadyTaken', { field: i18n.t('Occupation.occupation') }),
      },
    ],
    unitId: [
      {
        validation: validateRequired(),
        message: i18n => i18n.t('Error.required', { field: i18n.t('Occupation.unit') }),
      },
    ],
  };

  private selectOccupation(occupation: GQL_occupationSearch_occupationSearch) {
    this.occupationSelection.occupationId = occupation.id;
  }

  private addToCache(store: InMemoryCache, query: {data: GQL_createOccupationSelection }) {
    const data = (store.readQuery({ query: OCCUPATION_SELECTIONS }) as GQL_occupationSelections);
    if (!data || !query.data.createOccupationSelection?.occupationSelection) return;
    const occupation = query.data.createOccupationSelection.occupationSelection;
    data.currentUnit.occupationSelections.push(occupation);
    store.writeQuery({ query: OCCUPATION_SELECTIONS, data });

    try {
      const allOccupations = (store.readQuery({ query: ALL_OCCUPATIONS }) as GQL_occupations);
      allOccupations.currentUnit.occupations.push(occupation.occupation);
    } catch (e) {}

    return occupation;
  }

  private occupationSelectionCreated() {
    this.occupationSelection.occupationId = '';
    this.$sMessage.success(this.$t('Occupation.AddOccupations.success'));
  }
}
